import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import {
  HiOutlineCode,
  HiOutlineDeviceMobile,
  HiOutlinePencilAlt,
  HiOutlineCloud,
  HiOutlineSparkles,
  HiOutlineChatAlt2
} from 'react-icons/hi';

import './Services.css'; // Your services CSS file

// A list of your services
const servicesList = [
  {
    icon: <HiOutlineCode />,
    title: "Custom Web Development",
    description: "We build scalable, secure, and high-performance web applications tailored to your specific business needs, from complex dashboards to public-facing platforms.",
    detailedDescription: "We build exactly what you want. Whether you need a complex e-commerce platform, a bespoke dashboard, or a stunning corporate website, we've got you covered. Book a meeting and we can discuss your unique ideas and turn them into reality."
  },
  {
    icon: <HiOutlineDeviceMobile />,
    title: "Mobile App Development",
    description: "Reach your users on the go. We design and develop beautiful, high-performance native and cross-platform mobile apps for both iOS and Android.",
    detailedDescription: "We build exactly what you want. From engaging consumer apps to robust enterprise tools, we develop mobile solutions that users love. Book a meeting and we can discuss your unique ideas and turn them into reality."
  },
  {
    icon: <HiOutlinePencilAlt />,
    title: "UI/UX Design",
    description: "Great software is all about user experience. Our design team creates intuitive, engaging, and user-centric interfaces that delight users and drive adoption.",
    detailedDescription: "We build exactly what you want. Our design process ensures your application not only looks beautiful but is highly intuitive and user-friendly. Book a meeting and we can discuss your unique ideas and turn them into reality."
  },
  {
    icon: <HiOutlineCloud />,
    title: "Cloud & DevOps",
    description: "Modernize your infrastructure. We provide cloud migration, architecture, and DevOps services to improve scalability, reliability, and deployment speed.",
    detailedDescription: "We build exactly what you want. We set up robust and secure cloud infrastructures so your application scales seamlessly. Book a meeting and we can discuss your unique ideas and turn them into reality."
  },
  {
    icon: <HiOutlineSparkles />,
    title: "AI & Machine Learning",
    description: "Unlock the power of your data. Our experts can help you integrate AI and ML models to automate processes, gain insights, and create intelligent products.",
    detailedDescription: "We build exactly what you want. By integrating smart algorithms and predictive models, we make your application intelligent and future-ready. Book a meeting and we can discuss your unique ideas and turn them into reality."
  },
  {
    icon: <HiOutlineChatAlt2 />,
    title: "Digital Transformation",
    description: "Not sure where to start? We act as your strategic partner, guiding you through the technical landscape to choose the right solutions that drive real business value.",
    detailedDescription: "We build exactly what you want. We work closely with you as a strategic partner to map out the perfect digital journey for your business. Book a meeting and we can discuss your unique ideas and turn them into reality."
  }
];

export default function Services() {
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = 'https://www.ceylonext.com/services';
    document.title = 'Services | CeyloNext';
  }, []);

  // Stop background scrolling when modal is open
  useEffect(() => {
    if (selectedService) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedService]);

  const handleCloseModal = () => {
    setSelectedService(null);
  };

  return (
    <main className="main-content">
      <div className="hero-text">
        <h1>Our Services</h1>
        
        

      </div>
      {/* VVV  THIS IS THE TEXT TO CHANGE  VVV
          Replace the text inside the <p> tag below with your new paragraph.
        */}
        <p className="intro-paragraph">
          We engineer digital excellence from spark to scale. Whether crafting 
          high-performance software or pioneering custom IoT solutions, we are 
          your dedicated partners in shaping the future of technology.
        </p>
        {/* ^^^  END OF TEXT TO CHANGE  ^^^
        */}
      {/* New Service Grid */}
      <div className="services-grid">
        {servicesList.map((service, index) => (
          <div className="service-card" key={index} onClick={() => setSelectedService(service)}>
            <div className="service-icon">
              {service.icon}
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>

      {/* --- Service Detail Modal --- */}
      {selectedService && createPortal(
        <div className="service-modal-overlay" onClick={handleCloseModal}>
          <div className="service-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={handleCloseModal}>×</button>
            <div className="modal-icon">{selectedService.icon}</div>
            <h2>{selectedService.title}</h2>
            <p className="modal-description">{selectedService.detailedDescription}</p>
            
            <div className="modal-actions">
              <Link to="/contact" className="book-meeting-btn" onClick={handleCloseModal}>
                Book a Meeting
              </Link>
            </div>
          </div>
        </div>,
        document.body
      )}
    </main>
  );
}